import { FormGroup } from 'react-bootstrap';
import styled from 'styled-components';

const SeachFormGroup = styled(FormGroup)`
    width:50%;
    margin:30px 0;

    @media screen and (max-width:740px) {
       width: 70%;
    }
`;

export default SeachFormGroup;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormGroup.js